module.exports = __webpack_public_path__ + "img/helium.4745e56b.png";